export const socialMedia = ['facebook', 'linkedin', 'twitter'];
